import type { User } from "@book-club/shared";
import { useQuery } from "@tanstack/react-query";
import membersService from "@/features/members/services/membersService";
import DURATIONS from "@/shared/constants/durations";
import { membersKeys } from "./membersQueryKeys";

/**
 * Fetches a single member by ID
 * Uses normal staleTime (5 minutes)
 * @param uid - User ID
 * @returns Query result with member data or null
 */
export function useMemberById(uid: string) {
    return useQuery<User | null, Error>({
        enabled: !!uid,
        gcTime: DURATIONS.FIVE_MINUTES,
        queryFn: () => membersService.getMemberById(uid),
        queryKey: membersKeys.detail(uid),
        staleTime: DURATIONS.FIVE_MINUTES,
    });
}
